<template>
    <Wait_Skeleton v-if="!IsWait" />

    <Card v-if="IsWait" class="">
        <template #content>
            <div class="grid flex flex-wrap align-items-center justify-content-center">
                <div class="w-min md:w-max col-12 md-12 lg-12 ">
                </div>

                <div class="w-min md:w-max col-12 md-6 lg-4 ">
                    <div class="c-dashboardInfo ">
                        <div class="wrap">
                            <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title ">Ürün
                                Sayısı</h4>
                            <span class="hind-font caption-12 c-dashboardInfo__count">{{ UrunSayi }}</span>
                        </div>
                    </div>
                </div>
                <div class="w-min md:w-max col-12 md-6 lg-4 ">
                    <div class="c-dashboardInfo ">
                        <div class="wrap">
                            <h4 class="heading heading5 hind-font medium-font-weight c-dashboardInfo__title ">Müşteri
                                Sayısı </h4>
                            <span class="hind-font caption-12 c-dashboardInfo__count">{{ MusteriSayi }}</span>
                        </div>
                    </div>
                </div>
                <div class="w-min md:w-max col-12 md-12 lg-4 ">
                    <div class="c-dashboardInfo ">
                        <div class="wrap">

                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";
export default {
    data() {
        return {
            UrunSayi: "0",
            MusteriSayi: "0",
            IsWait: false
        };
    },
    methods: {
        _GetUrunSayi() {
            GlobalServis.GlobalServis("GET", "GetUrunSayi", "").then((res) => {
                if (res.status == 200) {
                    this.UrunSayi = res.data[0].UrunSayi;
                    this.IsWait = true;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        },
        _GetMusteriSayi() {
            GlobalServis.GlobalServis("GET", "GetMusteriSayi", "").then((res) => {
                if (res.status == 200) {
                    this.MusteriSayi = res.data[0].MusteriSayi;
                    this.IsWait = true;
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
            });
        }
    },
    created() {
        this._GetUrunSayi();
        this._GetMusteriSayi();
    },
    components: {
    },
};
</script>

<style scoped>
.c-dashboardInfo .wrap {
    background: #ffffff;
    box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);
    border-radius: 7px;
    border: 0.5px solid #EFD1FF;
    text-align: center;
    position: relative;
    overflow: hidden;
    padding: 10px 10px;
    height: 100%;
    width: 20vw;
}

.c-dashboardInfo__title {
    color: #6c6c6c;
    font-size: 1.18em;
}

.c-dashboardInfo__count {
    font-weight: 600;
    font-size: 2em;
    line-height: 25px;
    color: #323c43;
}

.c-dashboardInfo .wrap:after {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    content: "";
}

.c-dashboardInfo .wrap:after {
    background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);
}
</style>